import { makeStyles } from '@material-ui/styles';
import cn from 'clsx';

import { BoundModal, IconButton, CloseFill } from '@bizzabo/design-system';

interface ScheduleModalProps {
    isOpen: boolean;
    closeModal: () => void;
    contentClassName?: string;
}

const ScheduleModal: React.FC<ScheduleModalProps> = ({
    isOpen,
    closeModal,
    contentClassName,
    children,
}) => {
    const classes = useStyles();

    return (
        <BoundModal
            className={classes.modal}
            style={{ position: 'absolute' }}
            BackdropProps={{ style: { position: 'absolute' } }}
            open={isOpen}
            onClose={closeModal}
        >
            <div className={cn(classes.content, contentClassName)}>
                <IconButton
                    icon={CloseFill}
                    size="small"
                    className={classes.closeButton}
                    onClick={closeModal}
                />
                {children}
            </div>
        </BoundModal>
    );
};

const useStyles = makeStyles(
    theme => ({
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        content: {
            maxWidth: 500,
            width: '84%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
            padding: '40px 40px 20px',
            margin: '0 30px',
            borderRadius: 16,
            outline: 'none',
            background: theme.customization.background.C10,
        },
        closeButton: {
            position: 'absolute',
            top: 16,
            right: 16,
            background: 'none',
            color: theme.customization.background.G20,
            '& svg': {
                width: 20,
                height: 20,
            },
        },
    }),
    { classNamePrefix: 'schedule-modal' }
);

export default ScheduleModal;
